import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import {
	TestOptionFields,
	FrontendProduct,
	FrontendOrderItem,
} from "node-library/dist/portal";

import { CollapsibleCard } from "../../../common-components/card";
import {
	CustomIconButton,
	KebabDropdownButton,
	TextButton,
} from "../../../common-components/button";
import {
	DeleteIcon,
	EditIcon,
	TickIcon,
	SmallEditIcon,
	SmallDeleteIcon,
} from "../../../common-components/svgIcons";
import { NeutralColor } from "node-library/dist/colors";
import { Divider, IconButton, Tooltip } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import {
	calculateItemPrice,
	calculatePrice,
	formatPrice,
	getInstallFamiliarizeTranslationText,
	getIQSelectionAbbreviationText,
	getItemTagTextColor,
	getRepairOptionTranslationText,
	getServiceAmount,
} from "../../../helpers/sampleHelper";
import {
	InstallFamiliarizeOptions,
	OrderItemType,
	RepairOptions,
} from "node-library/dist/constants";

interface Props {
	handlingFee?: number;
	shippingFee?: number;
	description?: string;
	fullServiceShippingSolution?: boolean;
	currency: string;
	deleteFee: () => void;
	goToUpdateHandlingShippingFee: () => void;
	isReadOnlyTable?: boolean;
	isNestedCard?: boolean;
}

export default function HandlingShippingCard(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const [expanded, setExpanded] = useState(false);

	const {
		handlingFee,
		shippingFee,
		description,
		fullServiceShippingSolution,
		currency,
		deleteFee,
		goToUpdateHandlingShippingFee,
		isNestedCard,
	} = props;

	const itemCardContent: React.ReactNode = (
		<div className="item-preview-list-content">
			<div
				style={{
					backgroundColor: "#427891",
					color: "white",
				}}
				className="typography-caption overflow-ellipsis-text item-tag"
			>
				{translation("HandlingAndShipping")}
			</div>
			<div className={`item-preview-list-row`}>
				<div className="item-preview-info-column sample-preview-basic-info">
					<div className="typography-body-01">
						{handlingFee
							? translation("HandlingFee")
							: `${translation("ShippingFee")}${
									fullServiceShippingSolution
										? ` - ${translation("FullServiceShippingSolution")}`
										: ""
							  }`}
					</div>
				</div>
				<div className="item-preview-info-column sample-preview-basic-info">
					<div className="typography-heading-04 typography-bold overflow-ellipsis-text">
						{`${
							handlingFee
								? formatPrice(handlingFee, currency)
								: shippingFee
								? formatPrice(shippingFee, currency)
								: "--"
						}`}
					</div>
				</div>
				<div className="item-preview-button-column sample-preview-expand-button">
					<IconButton
						onClick={() => {
							setExpanded(!expanded);
						}}
					>
						{expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</div>
			</div>
		</div>
	);

	const actionRow: React.ReactNode = (
		<div
			style={{
				display: props.isReadOnlyTable ? "none" : "flex",
				width: "100%",
				justifyContent: "end",
				margin: "-10px 0",
			}}
		>
			<TextButton
				id={"edit-item-button"}
				onClick={() => {
					props.goToUpdateHandlingShippingFee();
				}}
				size="xsmall"
				buttonClassName="edit-item-button"
			>
				<SmallEditIcon></SmallEditIcon>
				<span className="typography-body-01">{translation("Edit")}</span>
			</TextButton>
			<TextButton
				id={"delete-item-button"}
				onClick={() => {
					props.deleteFee();
				}}
				size="xsmall"
				buttonClassName="edit-item-button"
			>
				<SmallDeleteIcon></SmallDeleteIcon>
				<span className="typography-body-01">{translation("Delete")}</span>
			</TextButton>
		</div>
	);
	const collapsibleContent: React.ReactNode = (
		<>
			<div
				className={`item-list-row item-preview-collapsible-content ${
					props.isReadOnlyTable ? "read-only" : ""
				}`}
			>
				<div className="item-preview-info-column item-preview-expanded-instrument-info-column">
					<div className="typography-body-02 view-item-info-description-row view-item-info-info-text">
						{`${translation("Description")}: `}
						<span className="wrap-text" style={{ whiteSpace: "pre-line" }}>
							{description}
						</span>
					</div>
				</div>
				{actionRow}
			</div>
		</>
	);

	const itemCard: React.ReactNode = (
		<CollapsibleCard
			className={isNestedCard ? "" : "common-card"}
			expanded={expanded}
			content={itemCardContent}
			collapsibleContent={collapsibleContent}
		></CollapsibleCard>
	);

	return itemCard;
}
